import {
    NotificationOptions,
    NotificationType,
} from '../../types/common/INotification';
import {
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
} from '../../constants/common/notifications.constants';
import NotificationsSlice from '../slices/NotificationsSlice';

export const NotificationActions = {
    error,
    info,
    success,
    warning,
    popNotification,
};

function error(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_ERROR,
        message,
        timestamp,
        options,
    );
}

function info(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
    shouldTranslate: boolean = true,
    notificationTimeout?: number,
) {
    return pushNotification(
        NOTIFICATION_TYPE_INFO,
        message,
        timestamp,
        options,
        shouldTranslate,
        notificationTimeout,
    );
}

function success(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_SUCCESS,
        message,
        timestamp,
        options,
    );
}

function warning(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_WARNING,
        message,
        timestamp,
        options,
    );
}

function popNotification(timestamp: number) {
    return NotificationsSlice.actions.pop(timestamp);
}

function pushNotification(
    type: NotificationType,
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
    shouldTranslate: boolean = true,
    notificationTimeout?: number,
) {
    const _timestamp = timestamp || Date.now();
    return NotificationsSlice.actions.push({
        type,
        message,
        timestamp: _timestamp,
        options,
        shouldTranslate,
        notificationTimeout,
    });
}
